import $ from 'cash-dom';

class Main {

    constructor() {
        this.init();
    }

    init() {
        $('.header__nav-toggle').on('click', e => this.headerNavToggleClickHandler(e));
    }

    headerNavToggleClickHandler(e) {
        $('.header__nav-toggle--open').toggleClass('d-none');
        $('.header__nav-toggle--close').toggleClass('d-none');

        if ($('.responsive-nav-wrapper').is(':hidden')) {
            this.currentScrollTop = $(document).scrollTop();

            $(document).scrollTop(0);
        }
        else {
            $(document).scrollTop(this.currentScrollTop);
        }

        $('.responsive-nav-wrapper').toggle();
    }
}

new Main();
